

<script>



</script>

<div class="page">
    <div class="container">
        <h1>Congratulation: Your payment is done</h1>
        <h1>You can click on the check coins button in the Billing page to confirm</h1>
    </div>
</div>

<style>
.page {
    width: 100vw;
    height: 100vh;
    background-color: bisque;
    display: flex;
    justify-content: center;
    align-items: center;
}

.container {
    width: 800px;
    height: 300px;
    border: 5px solid black;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
</style>
